import React, { useState } from "react";
import Slider from "react-slick";
import { images } from "./data";
import { PAGE_4 } from "./assets";
import styles from './SwiperContainer.module.scss';

function NextArrow(props) {
    const { onClick } = props;

    return (
        <div className={styles["nextArrow"]} onClick={onClick}>
            <img src={PAGE_4.RIGHT_ARROW.default} alt="Next arrow" />
        </div>
    )
};

function PrevArrow(props) {
    const { onClick } = props;

    return (
        <div className={styles["prevArrow"]} onClick={onClick}>
            <img src={PAGE_4.LEFT_ARROW.default} alt="Prev arrow" />
        </div>
    )
};

export default function SwiperContainer() {

    const [imageIndex, setImageIndex] = useState<number>(0);
    console.log('check img index', imageIndex);

    const customPaging = (n: number) => {
        return (
            <div className={styles["paging-container"]}>
                <img src={n === imageIndex ? PAGE_4.PAGER_ACTIVE.default : PAGE_4.PAGER.default}
                    alt="Pager"
                    className={styles["pager"]}
                />
            </div>
        )
    }

    return (
        <>
            <Slider infinite={true}
                lazyLoad={"ondemand"}
                speed={300}
                dots={true}
                customPaging={customPaging}
                slidesToShow={3}
                centerMode={true}
                centerPadding={"0"}
                nextArrow={<NextArrow />}
                prevArrow={<PrevArrow />}
                beforeChange={(current, next) => setImageIndex(next)}
                className={styles["slider-container"]}
            >
                {images.map((img, idx) => {
                    return (
                        <div className={idx === imageIndex ? styles["activeSlide"] : styles["slide"]}>
                            <img src={img} alt="swipermage" />
                        </div>
                    )
                })}
            </Slider>
        </>
    )
}